<!-- File Table -->
<div
	@fadeInOut
	*ngIf="renderTableHeader || renderTableBody"
	class="table-wrapper {{ styleClass }}"
>
	<!-- File Table Header -->
	<div
		@fadeInOut
		*ngIf="renderTableHeader"
		class="table-header fade fs-sx"
		[ngClass]="{
			'disabled': disableTableHeader,
			'show': !hideTableHeader
		}"
	>
		<ng-container>
			<div class="table-row row mx-0 pb-1 flex-nowrap align-items-center">
				<span
					*ngFor="let tableColumnItemConfig of fileDropTableConfig?.tableColumnItemsConfig; let isFirstRowCell=first; let isLastRowCell=last; let rowCellIdx=index"
					class="table-cell-wrapper
								{{ tableColumnItemConfig.colspan ? 'col-' + tableColumnItemConfig.colspan : 'col' }}
								{{ tableColumnItemConfig.headerStyleClass	?? '' }}
					"
					[ngClass]="{
						'ps-0': !isLastRowCell,
						'px-0': isLastRowCell,
						'text-start': tableColumnItemConfig.headerTextAlign === 'left',
						'text-center': tableColumnItemConfig.headerTextAlign === 'center',
						'text-end': tableColumnItemConfig.headerTextAlign === 'right'
					}"
				>
					<ng-template
						#defaultTableHeaderItemTpl
						let-isFirstRowCell="isFirstRowCell"
						let-isLastRowCell="isLastRowCell"
						let-rowCellIdx="rowCellIdx"
						let-tableColumnItemConfig="tableColumnItemConfig"
					>
						<ng-container [ngSwitch]="tableColumnItemConfig.identifier">

							<!-- ACTION DELETE -->
							<ng-container *ngSwitchCase="fileDropTableColumnIdEnum.ACTION_DELETE">
								<span
									@fadeInOut
									*ngIf="fileProcessConditionals?.deletableItemsExist"
									class="table-cell deleteAll link-text text-capitalize"
									[ngClass]="{
										'disabled': fileProcessConditionals?.importInProgress
									}"
									(click)="deleteInvalidItems()"
								>
									{{ getI18nString( false, 'shared.fileDrop.table.deleteAll' ) }}
								</span>
							</ng-container>

							<!-- FILE FULLNAME -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.FILE_FULL_NAME"
								class="table-cell fullname"
							>
								{{ getI18nString( false, 'shared.fileDrop.table.filename' ) }}
							</span>

							<!-- FILE FILESIZE -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.FILE_SIZE"
								class="table-cell filesize"
							>
								{{ getI18nString( false, 'shared.fileDrop.table.filesize' ) }}
							</span>

							<!-- FILE NAME -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.FILE_NAME"
								class="table-cell name"
							>
								{{ getI18nString( false, 'shared.fileDrop.table.filename' ) }}
							</span>

							<!-- PROCESS STATUS -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.PROCESS_STATUS"
								class="table-cell status"
							>
								{{ getI18nString( false, 'shared.fileDrop.table.status.label' ) }}
							</span>

							<!-- DEFAULT -->
							<span
								*ngSwitchDefault
								class="table-cell text-center"
							>-</span>
						</ng-container>
					</ng-template>

					<ng-template
						[ngTemplateOutlet]="tableColumnItemConfig?.headerEnforceCustomTemplate ? tableHeaderItemTpl : defaultTableHeaderItemTpl"
						[ngTemplateOutletContext]="{
							isFirstRowCell: isFirstRowCell,
							isLastRowCell: isLastRowCell,
							rowCellIdx: rowCellIdx,
							tableColumnItemConfig: tableColumnItemConfig
						}"
					></ng-template>
				</span>
			</div>
		</ng-container>
	</div>

	<!-- File Table Body -->
	<div
		@fadeInOut
		*ngIf="renderTableBody"
		class="table-body fade"
		[ngClass]="{
			'disabled': disableTableBody,
			'show': !hideTableBody
		}"
	>
		<ng-container *ngFor="let fileDropItem of fileDropList; let isFirstFile=first; let isLastFile=last; let fileIdx=index">

			<ng-container
				*ngIf="fileDropTableConfig?.group?.showGroups && fileDropItem?.metadata?.isGroupsFirstEntry"
				[ngTemplateOutlet]="groupHeaderTpl"
				[ngTemplateOutletContext]="{
					baseI18nPath: fileDropTableConfig?.group?.baseI18nPath,
					groupId: fileDropItem?.groupId,
					isFirstFile: isFirstFile,
					showGroupsTotalEntries: fileDropTableConfig?.group?.showGroupsTotalEntries,
					totalEntries: fileDropItem?.metadata?.groupsTotalEntries
				}"
			></ng-container>

			<div
				class="table-row row mx-0 py-1 flex-nowrap align-items-center"
				[ngClass]="{
					'isFirst': isFirstFile,
					'isLast': isLastFile || fileDropItem?.metadata?.isGroupsLastEntry
				}"
			>
				<span
					*ngFor="let tableColumnItemConfig of fileDropTableConfig?.tableColumnItemsConfig; let isFirstRowCell=first; let isLastRowCell=last; let rowCellIdx=index"
					class="
						table-cell-wrapper group-item
						{{ tableColumnItemConfig.colspan ? 'col-' + tableColumnItemConfig.colspan : 'col' }}
						{{	tableColumnItemConfig.bodyStyleClass	?? '' }}
					"
					[ngClass]="{
						'ps-0': fileDropTableConfig?.group?.showGroups && !isFirstRowCell ||
										!fileDropTableConfig?.group?.showGroups && !isLastRowCell,
						'px-0': isLastRowCell,
						'text-start': tableColumnItemConfig.bodyTextAlign === 'left',
						'text-center': tableColumnItemConfig.bodyTextAlign === 'center',
						'text-end': tableColumnItemConfig.bodyTextAlign === 'right'
					}"
				>
					<ng-template
						#defaultTableBodyItemTpl
						let-fileDropItem="fileDropItem"
						let-fileIdx="fileIdx"
						let-isFirstFile="isFirstFile"
						let-isFirstRowCell="isFirstRowCell"
						let-isLastFile="isLastFile"
						let-isLastRowCell="isLastRowCell"
						let-rowCellIdx="rowCellIdx"
						let-tableColumnItemConfig="tableColumnItemConfig"
					>
						<ng-container [ngSwitch]="tableColumnItemConfig.identifier">

							<!-- ACTION DELETE -->
							<ng-container *ngSwitchCase="fileDropTableColumnIdEnum.ACTION_DELETE">
								<app-action-item
									*ngIf="fileDropItem?.process?.status !== fileProcessStatusEnum.SUCCESS"
									[actionItem]="actionEnum.DELETE"
									[displayMode]="actionDisplayModeEnum.Standalone"
									[disabled]="fileProcessConditionals?.importInProgress"
									[iconNgClassMap]="{
										'text-format--error': fileDropItem?.process?.status === fileProcessStatusEnum.FAILED || fileDropItem?.process?.uploadForbidden
									}"
									[scopes]="[]"
									(clickEvent)="markFileDropItemAsDeleted(fileIdx)"
								></app-action-item>
							</ng-container>

							<!-- FULLNAME -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.FILE_FULL_NAME"
								class="table-cell"
								[ngClass]="{'text-format--error': fileDropItem.process?.errorMap?.has(fileDropErrorIdEnum.INVALID_NAME)}"
							>
								{{ fileDropItem?.fileData?.file.name }}
							</span>

							<!-- FILESIZE -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.FILE_SIZE"
								class="table-cell"
								[ngClass]="{'text-format--error': fileDropItem.process?.errorMap?.has(fileDropErrorIdEnum.MAX_FILESIZE)}"
							>
								{{ fileDropItem?.fileData?.prettyFilesize }}
							</span>

							<!-- FILENAME -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.FILE_NAME"
								class="table-cell"
								[ngClass]="{'text-format--error': fileDropItem.process?.errorMap?.has(fileDropErrorIdEnum.INVALID_NAME)}"
							>
								{{ fileDropItem?.fileData?.name }}
							</span>

							<!-- STATUS -->
							<span
								*ngSwitchCase="fileDropTableColumnIdEnum.PROCESS_STATUS"
								class="table-cell"
							>

								<!-- Uploading	-->
								<span
									*ngIf="(
													fileDropItem?.process?.status === fileProcessStatusEnum.UPLOADING ||
													fileDropItem?.process?.status === fileProcessStatusEnum.NOT_ASKED
												) && !fileDropItem?.process?.uploadForbidden"
									class="progress"
								>
									<span
										aria-valuemax="100"
										aria-valuemin="0"
										class="progress-bar" role="progressbar"
										[ngClass]="{
											'uploading progress-bar-striped progress-bar-animated': fileDropItem?.process?.status === fileProcessStatusEnum.UPLOADING
										}"
										[attr.aria-valuenow]="fileDropItem?.process?.uploadProgress"
										[ngStyle]="{'width': fileDropItem?.process?.uploadProgress + '%'}"
									>
										<span>{{ fileDropItem?.process?.uploadProgress + '%' }}</span>
									</span>
								</span>

								<!-- Success -->
								<span
									*ngIf="fileDropItem?.process?.status === fileProcessStatusEnum.SUCCESS"
									class="text-format--success"
								>
									{{ getI18nString( false, 'shared.fileDrop.table.status.success' ) }}
								</span>

								<!-- Error -->
								<span
									*ngIf="fileDropItem?.process?.errorMap?.size"
									class="text-format--error row mx-0 align-items-center"
								>

										<!-- Icon -->
										<i
											class="icon-info col-auto ps-0"
											[ngClass]="{
												'collapsing': fileDropService.doesFileDropsWithTooltipExist && !fileDropItem?.process.errorTooltipsExist,
												'd-none': !fileDropService.doesFileDropsWithTooltipExist
											}"
											appNgbTooltipExtended
											[container]="'body'"
											[tooltipClass]="'tooltip-format--error'"
											[tooltipValue]="errorTpl"
										>

											<!-- Tooltip -->
											<ng-template #errorTpl>
												<ng-container *ngFor="let fileDropError of fileDropService.getErrors(fileDropItem); let idx=index; let first=first">
													<span
														class="row mx-0 flex-column"
														[ngClass]="{'mt-3': !first}"
													>

														<!-- Error Label -->
														<span
															*ngIf="fileDropItem?.process?.errorMap.size > 1"
															class="fw-medium"
														>
															{{ getI18nString( false, fileDropError?.short ) }}
														</span>

														<!-- Error Description -->
														<span
															*ngIf="fileDropError?.long"
															class="fw-regular"
														>
															{{ getI18nStringParams( false, fileDropError?.long, fileDropError?.params, true, '-' ) }}
														</span>
													</span>
												</ng-container>
											</ng-template>
										</i>

										<!-- Label -->
										<span class="col px-0">
											{{ getI18nString( false, fileDropItem?.process?.errorLabel ) }}
										</span>
								</span>
							</span>

							<!-- DEFAULT -->
							<span
								*ngSwitchDefault
								class="table-cell text-center"
							>-</span>

						</ng-container>
					</ng-template>

					<ng-template
						[ngTemplateOutlet]="tableColumnItemConfig?.bodyEnforceCustomTemplate ? tableBodyItemTpl : defaultTableBodyItemTpl"
						[ngTemplateOutletContext]="{
							fileDropItem: fileDropItem,
							fileIdx: fileIdx,
							isFirstFile: isFirstFile,
							isFirstRowCell: isFirstRowCell,
							isLastFile: isLastFile,
							isLastRowCell: isLastRowCell,
							rowCellIdx: rowCellIdx,
							tableColumnItemConfig: tableColumnItemConfig
						}"
					></ng-template>
				</span>
			</div>
		</ng-container>
	</div>
</div>

<!-- ######################### TEMPLATES ######################### -->
<ng-template
	#groupHeaderTpl
	let-baseI18nPath="baseI18nPath"
	let-groupId="groupId"
	let-isFirstFile="isFirstFile"
	let-showGroupsTotalEntries="showGroupsTotalEntries"
	let-totalEntries="totalEntries"
>
	<div
		*ngIf="baseI18nPath"
		class="table-row row mx-0 py-1"
		[ngClass]="{
			'mt-4': !isFirstFile
		}"
	>
		<span class="table-cell-wrapper group-header">
			<span class="table-cell fw-medium">
				<span>{{ getI18nString( false, baseI18nPath + '.' + groupId ) }}</span>
				<span class="ms-1" *ngIf="showGroupsTotalEntries">( {{ totalEntries }} )</span>
			</span>
		</span>
	</div>
</ng-template>
